import React from 'react'
import PropTypes from 'prop-types'
import { isNil } from 'lodash-es'
import { SupplierResultShape } from './prop_shapes/SupplierResultShape'
import { Rating } from '../review_ratings'
import { IconVariant, SupplierIcon } from '../supplier_shared/supplier_icon'
import SupplierDesignations from '../supplier_shared/SupplierDesignations'
import ContactButton from './ContactButton'
import ProBadge from './ProBadge'
import SearchResultAction from './SearchResultAction'
import SearchResultLink from './SearchResultLink'
import SponsoredBadge from './SponsoredBadge'
import SupplierServiceArea from './SupplierServiceArea'

const isProSupplier = supplier => {
  if (isNil(supplier.subscription_expiry_date)) {
    return false
  } else {
    const today = new Date()
    today.setUTCHours(0, 0, 0, 0)
    return Date.parse(supplier.subscription_expiry_date) >= today
  }
}

// TODO put "mailto:" or contact_us_type in the search index
const contactButtonUrl = supplier => {
  const link = supplier.contact_us_link
  if (!link) {
    return null
  }
  return link.includes('://') ? link : `mailto:${link}`
}

const SearchResult = props => {
  const { supplier } = props
  const isPro = isProSupplier(supplier)
  const borderClass = props.sponsoredInCategoryId ? 'sponsored' : (isPro ? 'pro' : '')
  const hasRating = supplier.rounded_rating > 0
  const iconVariant = isPro ? IconVariant.LARGE : IconVariant.SMALL

  return (
    <div
      data-supplier-id={supplier.id}
      className={`supplier-search-result focusable ${borderClass}`}
    >
      <div className='supplier-search-result--content'>
        <div className='search-result-badge-container'>
          {props.sponsoredInCategoryId && <SponsoredBadge />}
          {isPro && <ProBadge />}
        </div>
        <div className='search-result-header'>
          <SearchResultLink {...props}>
            <SupplierIcon variant={iconVariant} id={supplier.id} name={supplier.name} logoUrl={supplier.logo} />
          </SearchResultLink>

          <div className='search-result-header--container'>
            <h3 className='heading-3 search-result-header--name'>
              <SearchResultLink {...props}>
                {supplier.name}
              </SearchResultLink>
            </h3>
            {hasRating && <Rating rating={supplier.rating} reviewCount={supplier.review_count} />}
            {isPro && contactButtonUrl(supplier) && <ContactButton url={contactButtonUrl(supplier)} />}
          </div>
        </div>

        {supplier.description && <div className='search-result-description body-small'>{supplier.description}</div>}

        <div className='search-result-bottom-details'>
          <div className='search-result-designations'>
            <SupplierDesignations
              designations={supplier.designation_tags}
            />
          </div>

          <SupplierServiceArea supplier={supplier} />
        </div>
      </div>

      <SearchResultAction>
        <SearchResultLink {...props}>
          {supplier.review_count > 0 ? `READ ${supplier.review_count} REVIEWS FROM PUBLIC SECTOR BUYERS` : 'VIEW PROFILE'}
        </SearchResultLink>
      </SearchResultAction>
    </div>
  )
}

SearchResult.propTypes = {
  supplier: SupplierResultShape.isRequired,
  sponsoredInCategoryId: PropTypes.number,
  searchId: PropTypes.number,
  onClick: PropTypes.func
}

SearchResult.defaultProps = {
  sponsoredInCategoryId: null,
  searchId: null,
  onClick: null
}

export default SearchResult
